import { createContext, useContext, useState, useCallback } from "react";
import { strings } from "@/i18n/translations";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("brilla_lang") || "en");

  const toggle = useCallback(() => {
    setLang((prev) => {
      const next = prev === "en" ? "es" : "en";
      localStorage.setItem("brilla_lang", next);
      return next;
    });
  }, []);

  const setLanguage = useCallback((l) => {
    localStorage.setItem("brilla_lang", l);
    setLang(l);
  }, []);

  // translate helper: t("dashboard.welcome")
  const t = useCallback(
    (key) => {
      const parts = key.split(".");
      let node = strings[lang];
      for (const p of parts) {
        node = node?.[p];
        if (node == null) break;
      }
      if (node == null) {
        // fallback to english
        let en = strings.en;
        for (const p of parts) en = en?.[p];
        return en ?? key;
      }
      return node;
    },
    [lang]
  );

  return (
    <LanguageContext.Provider value={{ lang, toggle, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLang = () => useContext(LanguageContext);
